import React from 'react';
import { components } from 'react-select';
import Async from 'react-select/async';
import { stringify as queryify } from 'qs';
import memoize from 'memoizee';
import useGlobalState from '../../hooks/use-global-state';
import { setLocation } from '../../modules/app-duck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';
import { colors } from '../../modules/theme';

const searchLocation = memoize(value => {
  const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${value}.json`;
  const query = queryify({
    access_token: process.env.REACT_APP_MAPBOX_API_TOKEN, // eslint-disable-line camelcase
    country: 'au',
    limit: 10,
  });

  return fetch(`${url}?${query}`)
    .then(x => x.json())
    .then(x => {
      return x.features.map(({ center, place_name }) => ({
        value: center,
        label: place_name,
      }));
    });
});

const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <FontAwesomeIcon icon={faSearch} style={{ color: colors.blue }} />
    </components.DropdownIndicator>
  );
};

export default function LocationSearch({ onChange, value }) {
  const { state, dispatch } = useGlobalState();

  return (
    <Async
      styles={{
        input: s => ({
          ...s,
          border: 'none !important',
          background: 'none !important',
        }),
        placeholder: s => ({
          ...s,
          fontStyle: 'italic',
        }),
      }}
      placeholder="Search address"
      onChange={x => dispatch(setLocation(x))}
      components={{ DropdownIndicator: DropdownIndicator }}
      value={state.location}
      loadOptions={searchLocation}
      isClearable={true}
    />
  );
}
